import { TObject } from "../../common/TObject";
import { Z_BLOCK } from "zlib";

export enum ToolBarState {
    UNKNOWN = "Unknown",
    EDIT = "edit",
    INSERT = "insert",
    MOVE = "move",
    DRAW = "draw",
    ROUTE = "route",
}

export class Toolbar extends TObject {
    crmmap: any;
    map: any;
    state: ToolBarState = ToolBarState.UNKNOWN;
    elements: HTMLElement[] = [];
    serachbutton: HTMLButtonElement = null;
    serachBox: HTMLInputElement = null;
    serachbusy: NodeListOf<HTMLDivElement> = null;

    busy: boolean = false;

    element: HTMLElement = null;

    constructor(crmmap, map) {
        super(crmmap);
        this.crmmap = crmmap;
        this.map = map;

        this.element = <HTMLElement>document.getElementById('searchbox');


        this.serachbutton = <HTMLButtonElement>document.getElementById('serachbutton');
        this.serachBox = <HTMLInputElement>document.getElementById('pac-input');

        this.serachbusy = document.querySelectorAll('.serachbusy');





        [].forEach.call(document.querySelectorAll('.toolbarstate'), (element) => {
            const state = element.getAttribute('state');
            this.elements[state] = element;
            element.addEventListener('click', (e) => { this.setState(e.currentTarget); }, true);
        });


        if (this.serachbutton) {
            this.serachbutton.addEventListener('click', (e) => {
                this.debug('serachbutton click');
                this.debug(this.serachBox.value);
                this.crmmap.Map.Search.doSearch(this.serachBox.value);
            }, true);
        }

        var reloadbutton = <HTMLButtonElement>this.element.querySelector('.reload');
        if (reloadbutton) {
            this.debug(reloadbutton);
            reloadbutton.onclick = () => {
                this.crmmap.Map.Search.refresh();
            }
        }

        setTimeout(()=>{
            this.setState(ToolBarState.EDIT);
        }, 1000);
        this.setBusy(false);
    }

    setBusy(to: boolean) {
        this.busy = to;
       // this.serachbusy.style.display = this.busy ? 'block' : 'none';

        Array.from(this.serachbusy).forEach((el) => { 
            el.style.display = this.busy ? 'block' : 'none';
        });
    }

    setState(bt, dotriggers = true) {
        var to = bt;
        var msg = false;
        if (!(typeof bt === 'string' || bt instanceof String)) {
            to = bt.getAttribute('state');
            msg = bt.getAttribute('msg');
        }
        this.state = to;
        this.debug('State:' + this.state);


        //set body tag
        Object.keys(ToolBarState).map(key => {
            document.body.classList.remove('state' + ToolBarState[key]);
        });
        document.body.classList.add('state' + to);
        if (msg) {
            this.crmmap.showstatus(msg, 1000);
        }

        //Set button states (should do this with css but for now this will do)
        [].forEach.call(document.querySelectorAll('.toolbarstate'), (element) => {
            element.classList.remove('btn-primary');
            element.classList.remove('active');
            element.classList.add('btn-default');
        });
        this.elements[this.state].classList.remove('btn-default');
        this.elements[this.state].classList.add('btn-primary');
        this.elements[this.state].classList.add('active');


        var setDrawView = true;


        this.serachbutton.innerHTML = `<i class="${this.elements[this.state].dataset.icon}" />`;
        this.serachbutton.style.backgroundColor = this.elements[this.state].dataset.color;
        this.serachBox.placeholder = this.elements[this.state].dataset.placeholder;

        /* 
                export enum StateIcons {
                    UNKNOWN = "Unknown",
                    EDIT = "edit",
                    INSERT = "quickadd",
                    MOVE = "move",
                    DRAW = "draw",
                    ROUTE = "route",
                } */

        if (dotriggers) {

            switch (this.state) {
                case ToolBarState.EDIT:
                    this.crmmap.Sidebar.showMenu('right', false);
                    this.map.setOptions({ gestureHandling: 'auto', draggableCursor: 'pointer' });
                    break;
                case ToolBarState.INSERT:
                    this.crmmap.Sidebar.showMenu('right', false);
                    this.map.setOptions({ gestureHandling: 'greedy', draggableCursor: 'crosshair' });
                    this.crmmap.Data.Status.get();
                    this.crmmap.Data.Items.get();
                    break;
                case ToolBarState.DRAW:
                    this.crmmap.Sidebar.showMenu('right', 'draw');
                    setDrawView = false;
                    if (this.crmmap.Map.Drawing) {
                        this.crmmap.Map.Drawing.editMode();
                    }
                    break;
                case ToolBarState.MOVE:
                    //  this.crmmap.Sidebar.showMenu('right', false);
                    this.map.setOptions({ gestureHandling: 'greedy', draggableCursor: '' });
                    break;
                case ToolBarState.ROUTE:
                    this.map.setOptions({ gestureHandling: 'auto', draggableCursor: 'crosshair' });
                    this.crmmap.Sidebar.showMenu('right', 'routes');

                    break;
                default:
                    this.crmmap.Sidebar.showMenu('right', false);

                    console.log("Unknown toolbar state", this.state);
                    break;
            }

            if (setDrawView) {
                if (this.crmmap.Map.Drawing) {
                    this.crmmap.Map.Drawing.viewMode();
                }
            }
            if (this.crmmap.Map.Routes) {
                this.crmmap.Map.Routes.setVisible(this.state == ToolBarState.ROUTE);
            }
            this.changed(this.state);
        }





    }


    setMove() {
        this.setState(ToolBarState.MOVE);
    }

    setInsert() {
        this.setState(ToolBarState.INSERT);
    }

    setDraw() {
        this.setState(ToolBarState.DRAW);
    }




}
